module.exports = __webpack_public_path__ + "img/weather.37986a5f.png";